var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 29.5H24.75M12.5 29.5C22.125 25.125 13.9 18.3 17.75 12M17.75 12C17.6696 9.52576 18.3408 7.08523 19.675 5C21.25 3.25 23.525 1.675 28.25 1.5C28.075 5.525 27.025 7.8 25.275 9.55C23.525 10.95 21.075 11.825 17.75 12ZM11.625 10.95C13.55 12.35 14.775 14.8 15.65 17.425C12.15 18.125 9.525 18.125 7.25 16.9C5.15 15.85 3.225 13.575 2 9.55C6.9 8.675 9.7 9.55 11.625 10.95Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.3944b9abe70af8eb1e1e2a3c7aa43b94.svg";
export { ForwardRef as ReactComponent };